<script setup lang="ts">
import { useRegisterSW } from 'virtual:pwa-register/vue'
import { pwaInfo } from 'virtual:pwa-info'

console.log(pwaInfo)

// replaced dyanmicaly
const reloadSW: any = '__RELOAD_SW__'

const {
    offlineReady,
    needRefresh,
    updateServiceWorker,
} = useRegisterSW({
    immediate: true,
    onRegisteredSW(swUrl, r) {
        console.log(`Service Worker at: ${swUrl}`)
        if (reloadSW === 'true') {
            r && setInterval(async () => {
                console.log('Checking for sw update')
                await r.update()
            }, 20000 /* 20s for testing purposes */)
        }
        else {
            console.log(`SW Registered: ${r}`)
        }
    },
})

async function close() {
    offlineReady.value = false
    needRefresh.value = false
}
</script>

<template>
    <div v-if="offlineReady || needRefresh" class="pwa-toast bg-sky-200" role="alert">
        <div class="message">
            <span v-if="offlineReady">
                Aplikacja gotowa, aby działać offline
            </span>
            <span v-else>
                Dostępna nowa wersja, kliknij odśwież, aby zaktualizować
            </span>
        </div>
        <button v-if="needRefresh" @click="updateServiceWorker()">
            Odśwież
        </button>
        <button @click="close">
            Zamknij
        </button>
    </div>
</template>

<style>
.pwa-toast {
    position: fixed;
    right: 0;
    bottom: 0;
    margin: 16px;
    padding: 12px;
    border-radius: 4px;
    z-index: 9999;
    text-align: left;
    box-shadow: 3px 4px 5px 0px #8885;
}

.pwa-toast .message {
    margin-bottom: 8px;
}

.pwa-toast button {
    border: 1px solid #8885;
    outline: none;
    margin-right: 5px;
    border-radius: 2px;
    padding: 3px 10px;
}
</style>
